module.exports = {
  locales: [
    {
      code: 'th',
      hrefLang: 'th-TH',
      name: 'Thai',
      localName: 'ภาษาไทย',
    },
    {
      code: 'en',
      hrefLang: 'en-US',
      name: 'English',
      localName: 'English',
    },
  ],

  defaultLocale: 'th',

  resolveMessages: locale => {
    return {
      ...require(`swp-components/lib/assets/translations/${locale}.json`),
      ...require(`./src/translations/${locale}.json`),
    }
  },
}
